// languages/chineseTraditional.js
export const chineseTraditional = {
  name: "繁體中文",
  interface: {
    welcome: "歡迎",
    chooseLanguage: "選擇語言",
    continue: "繼續",
    backToMap: "返回地圖",
    achievement: "成就",
    viewInAR: "在AR中查看",
    menu: {
      menu: "選單",
      home: "首頁",
      language: "語言",
      achievement: "成就",
      unsuiExperience: "雲水體驗",
      feedback: "回饋",
    },
    buyScreen: {
      clickToBuy: "點擊購買寺廟",
      templeExperience: "的特別體驗！",
      description1: "透過音頻導覽聆聽關",
      description2: "於寺廟的迷人故事，",
      description3: "並享受神奇的AR體驗！",
      buy: "購買",
    },
    gift: {
      congratulations: "恭喜！",
      yourGift: "你的禮物",
      giftTitle: "The Supreme Truth",
      giftText: "Check out this amazing gift!",
    },
  },
};
